'use client';

import { Button } from '@sprd/sprd-component-kit/v2';
import React, { useEffect, useState } from 'react';
import clsx from 'clsx';
import { useTranslations } from 'next-intl';
import { usePathname } from 'next/navigation';
import { TermsAndConditionsModule } from '@/types/amplience';
import AmplienceLink from '../Common/AmplienceLink';

export default function TermsAndConditions({
  content,
  className,
  bodyItems,
}: {
  content: TermsAndConditionsModule;
  className?: string;
  bodyItems: React.ReactNode[];
}) {
  const currentUrl = usePathname();
  const [selectedIndex, setSelectedIndex] = useState<number>(0);
  const t = useTranslations('termsAndConditions');

  useEffect(() => {
    const matchedIndex =
      content.termsAndConditionsList.findIndex((item) => currentUrl.endsWith(item.linkURL.url)) ??
      -1;
    if (matchedIndex !== -1) {
      setSelectedIndex(matchedIndex);
    }
  }, [currentUrl, content.termsAndConditionsList]);

  function handlePrint() {
    window.print();
  }
  return (
    <div className={`flex flex-col text-gray-700 md:flex-row ${className}`}>
      <aside className="p-4 md:w-1/4 print:hidden">
        <h2 className="mb-4 text-lg font-bold">{content.headline}</h2>
        <ul className="space-y-2 text-sm lg:text-base xl:text-lg">
          {content.termsAndConditionsList.map((item, index) => (
            <li key={index} className="flex flex-col gap-1">
              <AmplienceLink
                link={item.linkURL}
                className={clsx(
                  'cursor-pointer rounded px-4 py-4',
                  selectedIndex === index ? 'bg-gray-200 font-semibold' : 'hover:bg-gray-200'
                )}
              >
                {item.linkURL.label}
              </AmplienceLink>
            </li>
          ))}
        </ul>
      </aside>
      <section className="p-6 md:w-3/4">
        <div className="text-sm lg:text-base xl:text-lg">{bodyItems[selectedIndex]}</div>
        <div className="mt-4">
          <Button
            size={'m'}
            variant={'primary'}
            onClick={() => handlePrint()}
            className="px-6 py-3 font-bold print:hidden"
          >
            {t('printButton')}
          </Button>
        </div>
      </section>
    </div>
  );
}
